// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2d_lJ","subheader":"ReorderModal_subheader__34QSP","listWrap":"ReorderModal_listWrap__19kmR"};